import { useEffect, useRef } from 'react';
import { DropdownMenuItem } from '@alltrails/denali/components/DropdownMenu';
import Directions from '@alltrails/denali/icons/Directions';
import HandWaving from '@alltrails/denali/icons/HandWaving';
import { SPACE_150 } from '@alltrails/denali/tokens';
import { useAppSelector } from '../../../redux';
import type { Coordinates } from '../../../types/Geo';
import type PopupOffset from '../../../types/PopupOffset';
import PaddingAwarePopup from '../../PaddingAwarePopup';
import styles from '../Segments/ContextMenu.module.scss';

const offset: PopupOffset = {
  bottom: [0, -SPACE_150],
  'bottom-left': [SPACE_150, -SPACE_150],
  'bottom-right': [-SPACE_150, -SPACE_150],
  top: [0, SPACE_150],
  'top-left': [SPACE_150, SPACE_150],
  'top-right': [-SPACE_150, SPACE_150],
  left: [SPACE_150, 0],
  right: [-SPACE_150, 0]
};

type InactiveSegmentMenuProps = {
  coordinates: Coordinates;
  onClose: () => void;
  onRouteToPoint: () => void;
  onSelectSegment: () => void;
  segmentIndex: number;
};

const InactiveSegmentMenu = ({ coordinates, onClose, onRouteToPoint, onSelectSegment, segmentIndex }: InactiveSegmentMenuProps) => {
  const { activeSegmentIndex, segmentCount, segmentPaths } = useAppSelector(state => ({
    activeSegmentIndex: state.customRoute.activeSegmentIndex,
    segmentCount: state.customRoute.route.segments.length,
    segmentPaths: state.customRoute.route.segments[segmentIndex]?.paths
  }));
  const openedWithRef = useRef({ activeSegmentIndex, segmentCount, segmentPaths });

  useEffect(() => {
    const openedWith = openedWithRef.current;
    if (
      activeSegmentIndex !== openedWith.activeSegmentIndex ||
      segmentCount !== openedWith.segmentCount ||
      segmentPaths !== openedWith.segmentPaths
    ) {
      onClose();
    }
  }, [activeSegmentIndex, onClose, segmentCount, segmentPaths]);

  return (
    <PaddingAwarePopup
      className={styles.container}
      closeButton={false}
      closeOnClick={false}
      closeOnMapClick
      focusAfterOpen
      latitude={coordinates.lat}
      longitude={coordinates.lng}
      maxWidth="320"
      offset={offset}
      onClose={onClose}
    >
      <DropdownMenuItem
        option={{
          leadingIcon: { icon: { Component: Directions } },
          onClick: onRouteToPoint,
          // TODO: ADV-335 translate
          title: 'Route to point'
        }}
        textVariant="text100"
      />
      <DropdownMenuItem
        option={{
          leadingIcon: { icon: { Component: HandWaving } },
          onClick: onSelectSegment,
          // TODO: ADV-335 translate
          title: 'Select segment'
        }}
        textVariant="text100"
      />
    </PaddingAwarePopup>
  );
};

export default InactiveSegmentMenu;
